// extracted by mini-css-extract-plugin
module.exports = {"modalDescription":"_3490Z","smallModal":"_1Dt0R","button":"_31EjJ"};